function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, Array, Object, String, data) {
    var h = require("panel").h;
    var __vjadeSafeCode = function(code) {
      return code || String(code);
    };
    return {
      value: (h("div", {
        "class": {
          'bar_chart': true
        },
      }, (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("table", {
          "class": {
            'bar_chart_table': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("tr", {
            "class": {
              'chart_header': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("th", {
              "class": {
                'chart_header_right': true
              },
            }, [__vjadeSafeCode($attr(`interval-title`))]));
            __jade_nodes = __jade_nodes.concat(h("th", (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat("Segment");;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this).filter(Boolean)));
          __jade_nodes = __jade_nodes.concat((function() {
            var $$obj = (data);
            var $$eachNodes;
            var $$iterated = false;
            if (Array.isArray($$obj)) {
              $$eachNodes = $$obj.reduce(function($$eachNodes, row, rowIndex) {
                $$iterated = true;
                return $$eachNodes.concat((function() {
                  var __jade_nodes = [];
                  const {
                    label,
                    segments,
                    text,
                    queryIndex
                  } = row;;
                  __jade_nodes = __jade_nodes.concat(h("tr", {
                    "class": Object.assign({}, {
                      'first_chart_row': rowIndex === 0
                    }, {
                      'chart_row': true
                    }),
                  }, (function() {
                    var __jade_nodes = [];
                    __jade_nodes = __jade_nodes.concat(h("td", {
                      "class": {
                        'chart_labels': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat(h("div", {
                        "class": {
                          'chart_label_container': true
                        },
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'label': true
                          },
                        }, [__vjadeSafeCode(label)]));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));
                    __jade_nodes = __jade_nodes.concat(h("td", {
                      "class": {
                        'chart_body': true
                      },
                    }, (function() {
                      var __jade_nodes = [];
                      __jade_nodes = __jade_nodes.concat((text) ? ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("div", {
                          "class": {
                            'bar_chart_label': true
                          },
                        }, [__vjadeSafeCode(text)]));;
                        return __jade_nodes
                      }).call(this)) : ((function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("ul", {
                          "class": {
                            'bar_container_group': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat((function() {
                            var $$obj = (segments);
                            var $$eachNodes;
                            var $$iterated = false;
                            if (Array.isArray($$obj)) {
                              $$eachNodes = $$obj.reduce(function($$eachNodes, segment, segmentIndex) {
                                $$iterated = true;
                                return $$eachNodes.concat((function() {
                                  var __jade_nodes = [];
                                  __jade_nodes = __jade_nodes.concat(h("li", {
                                    "class": {
                                      'bar_container': true
                                    },
                                  }, (function() {
                                    var __jade_nodes = [];
                                    const {
                                      color,
                                      count,
                                      isClickable,
                                      isSelected
                                    } = segment;
                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                      "on": {
                                        click: isClickable ? ev => $helpers.clickBar(segment, label, rowIndex, queryIndex, ev) : null,
                                        mousemove: ev => $helpers.handleMouseMove(row, segmentIndex, false, ev),
                                        mouseleave: $helpers.handleMouseLeave,
                                      },
                                      "style": $helpers.formatBarStyle(segment),
                                      "class": Object.assign({}, {
                                        'not-clickable': !isClickable,
                                        'selected': !!isSelected
                                      }, {
                                        'bar': true,
                                        'hoverable': true
                                      }),
                                    }));
                                    __jade_nodes = __jade_nodes.concat(h("div", {
                                      "style": {
                                        width: `${100-$helpers.formatBarWidth(segment)}%`
                                      },
                                      "class": {
                                        'bar': true,
                                        'empty': true
                                      },
                                    }, (function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("div", {
                                        "class": {
                                          'bar_value': true
                                        },
                                      }, [__vjadeSafeCode($attr(`display-relative`) && !$helpers.isNil(segment.percentage) ? `${segment.percentage}%` : $helpers.commaizeNumber(segment.count))]));
                                      __jade_nodes = __jade_nodes.concat((segment.annotation) ? ((function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                          "class": {
                                            'annotation_line': true
                                          },
                                        }));;
                                        return __jade_nodes
                                      }).call(this)) : undefined);;
                                      return __jade_nodes
                                    }).call(this).filter(Boolean)));
                                    __jade_nodes = __jade_nodes.concat((segment.annotation) ? ((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("div", {
                                        "class": {
                                          'annotation_container': true
                                        },
                                      }, (function() {
                                        var __jade_nodes = [];
                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                          "on": {
                                            mousemove: ev => $helpers.handleMouseMove(row, segmentIndex, true, ev),
                                            mouseleave: $helpers.handleMouseLeave,
                                          },
                                          "class": {
                                            'annotation_label': true
                                          },
                                        }, (function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(h("div", {
                                            "style": $helpers.formatAnnotationStyle(segment),
                                            "class": {
                                              'color-indicator': true
                                            },
                                          }));
                                          __jade_nodes = __jade_nodes.concat("" + (segment.annotation.value) + "");;
                                          return __jade_nodes
                                        }).call(this).filter(Boolean)));;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this)) : undefined);;
                                    return __jade_nodes
                                  }).call(this).filter(Boolean)));;
                                  return __jade_nodes
                                }).call(this));
                              }, []);
                            } else {
                              $$eachNodes = [];
                              for (var $$objKey in $$obj) {
                                (function() {
                                  var segmentIndex = $$objKey;
                                  if ($$obj.hasOwnProperty(segmentIndex)) {
                                    $$iterated = true;
                                    var segment = $$obj[segmentIndex];
                                    $$eachNodes = $$eachNodes.concat((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("li", {
                                        "class": {
                                          'bar_container': true
                                        },
                                      }, (function() {
                                        var __jade_nodes = [];
                                        const {
                                          color,
                                          count,
                                          isClickable,
                                          isSelected
                                        } = segment;
                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                          "on": {
                                            click: isClickable ? ev => $helpers.clickBar(segment, label, rowIndex, queryIndex, ev) : null,
                                            mousemove: ev => $helpers.handleMouseMove(row, segmentIndex, false, ev),
                                            mouseleave: $helpers.handleMouseLeave,
                                          },
                                          "style": $helpers.formatBarStyle(segment),
                                          "class": Object.assign({}, {
                                            'not-clickable': !isClickable,
                                            'selected': !!isSelected
                                          }, {
                                            'bar': true,
                                            'hoverable': true
                                          }),
                                        }));
                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                          "style": {
                                            width: `${100-$helpers.formatBarWidth(segment)}%`
                                          },
                                          "class": {
                                            'bar': true,
                                            'empty': true
                                          },
                                        }, (function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(h("div", {
                                            "class": {
                                              'bar_value': true
                                            },
                                          }, [__vjadeSafeCode($attr(`display-relative`) && !$helpers.isNil(segment.percentage) ? `${segment.percentage}%` : $helpers.commaizeNumber(segment.count))]));
                                          __jade_nodes = __jade_nodes.concat((segment.annotation) ? ((function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "class": {
                                                'annotation_line': true
                                              },
                                            }));;
                                            return __jade_nodes
                                          }).call(this)) : undefined);;
                                          return __jade_nodes
                                        }).call(this).filter(Boolean)));
                                        __jade_nodes = __jade_nodes.concat((segment.annotation) ? ((function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(h("div", {
                                            "class": {
                                              'annotation_container': true
                                            },
                                          }, (function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "on": {
                                                mousemove: ev => $helpers.handleMouseMove(row, segmentIndex, true, ev),
                                                mouseleave: $helpers.handleMouseLeave,
                                              },
                                              "class": {
                                                'annotation_label': true
                                              },
                                            }, (function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat(h("div", {
                                                "style": $helpers.formatAnnotationStyle(segment),
                                                "class": {
                                                  'color-indicator': true
                                                },
                                              }));
                                              __jade_nodes = __jade_nodes.concat("" + (segment.annotation.value) + "");;
                                              return __jade_nodes
                                            }).call(this).filter(Boolean)));;
                                            return __jade_nodes
                                          }).call(this).filter(Boolean)));;
                                          return __jade_nodes
                                        }).call(this)) : undefined);;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this));
                                  }
                                })();
                              }
                            }

                            return $$eachNodes;
                          })());;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this)));;
                      return __jade_nodes
                    }).call(this).filter(Boolean)));;
                    return __jade_nodes
                  }).call(this).filter(Boolean)));;
                  return __jade_nodes
                }).call(this));
              }, []);
            } else {
              $$eachNodes = [];
              for (var $$objKey in $$obj) {
                (function() {
                  var rowIndex = $$objKey;
                  if ($$obj.hasOwnProperty(rowIndex)) {
                    $$iterated = true;
                    var row = $$obj[rowIndex];
                    $$eachNodes = $$eachNodes.concat((function() {
                      var __jade_nodes = [];
                      const {
                        label,
                        segments,
                        text,
                        queryIndex
                      } = row;;
                      __jade_nodes = __jade_nodes.concat(h("tr", {
                        "class": Object.assign({}, {
                          'first_chart_row': rowIndex === 0
                        }, {
                          'chart_row': true
                        }),
                      }, (function() {
                        var __jade_nodes = [];
                        __jade_nodes = __jade_nodes.concat(h("td", {
                          "class": {
                            'chart_labels': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat(h("div", {
                            "class": {
                              'chart_label_container': true
                            },
                          }, (function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'label': true
                              },
                            }, [__vjadeSafeCode(label)]));;
                            return __jade_nodes
                          }).call(this).filter(Boolean)));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));
                        __jade_nodes = __jade_nodes.concat(h("td", {
                          "class": {
                            'chart_body': true
                          },
                        }, (function() {
                          var __jade_nodes = [];
                          __jade_nodes = __jade_nodes.concat((text) ? ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("div", {
                              "class": {
                                'bar_chart_label': true
                              },
                            }, [__vjadeSafeCode(text)]));;
                            return __jade_nodes
                          }).call(this)) : ((function() {
                            var __jade_nodes = [];
                            __jade_nodes = __jade_nodes.concat(h("ul", {
                              "class": {
                                'bar_container_group': true
                              },
                            }, (function() {
                              var __jade_nodes = [];
                              __jade_nodes = __jade_nodes.concat((function() {
                                var $$obj = (segments);
                                var $$eachNodes;
                                var $$iterated = false;
                                if (Array.isArray($$obj)) {
                                  $$eachNodes = $$obj.reduce(function($$eachNodes, segment, segmentIndex) {
                                    $$iterated = true;
                                    return $$eachNodes.concat((function() {
                                      var __jade_nodes = [];
                                      __jade_nodes = __jade_nodes.concat(h("li", {
                                        "class": {
                                          'bar_container': true
                                        },
                                      }, (function() {
                                        var __jade_nodes = [];
                                        const {
                                          color,
                                          count,
                                          isClickable,
                                          isSelected
                                        } = segment;
                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                          "on": {
                                            click: isClickable ? ev => $helpers.clickBar(segment, label, rowIndex, queryIndex, ev) : null,
                                            mousemove: ev => $helpers.handleMouseMove(row, segmentIndex, false, ev),
                                            mouseleave: $helpers.handleMouseLeave,
                                          },
                                          "style": $helpers.formatBarStyle(segment),
                                          "class": Object.assign({}, {
                                            'not-clickable': !isClickable,
                                            'selected': !!isSelected
                                          }, {
                                            'bar': true,
                                            'hoverable': true
                                          }),
                                        }));
                                        __jade_nodes = __jade_nodes.concat(h("div", {
                                          "style": {
                                            width: `${100-$helpers.formatBarWidth(segment)}%`
                                          },
                                          "class": {
                                            'bar': true,
                                            'empty': true
                                          },
                                        }, (function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(h("div", {
                                            "class": {
                                              'bar_value': true
                                            },
                                          }, [__vjadeSafeCode($attr(`display-relative`) && !$helpers.isNil(segment.percentage) ? `${segment.percentage}%` : $helpers.commaizeNumber(segment.count))]));
                                          __jade_nodes = __jade_nodes.concat((segment.annotation) ? ((function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "class": {
                                                'annotation_line': true
                                              },
                                            }));;
                                            return __jade_nodes
                                          }).call(this)) : undefined);;
                                          return __jade_nodes
                                        }).call(this).filter(Boolean)));
                                        __jade_nodes = __jade_nodes.concat((segment.annotation) ? ((function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(h("div", {
                                            "class": {
                                              'annotation_container': true
                                            },
                                          }, (function() {
                                            var __jade_nodes = [];
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "on": {
                                                mousemove: ev => $helpers.handleMouseMove(row, segmentIndex, true, ev),
                                                mouseleave: $helpers.handleMouseLeave,
                                              },
                                              "class": {
                                                'annotation_label': true
                                              },
                                            }, (function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat(h("div", {
                                                "style": $helpers.formatAnnotationStyle(segment),
                                                "class": {
                                                  'color-indicator': true
                                                },
                                              }));
                                              __jade_nodes = __jade_nodes.concat("" + (segment.annotation.value) + "");;
                                              return __jade_nodes
                                            }).call(this).filter(Boolean)));;
                                            return __jade_nodes
                                          }).call(this).filter(Boolean)));;
                                          return __jade_nodes
                                        }).call(this)) : undefined);;
                                        return __jade_nodes
                                      }).call(this).filter(Boolean)));;
                                      return __jade_nodes
                                    }).call(this));
                                  }, []);
                                } else {
                                  $$eachNodes = [];
                                  for (var $$objKey in $$obj) {
                                    (function() {
                                      var segmentIndex = $$objKey;
                                      if ($$obj.hasOwnProperty(segmentIndex)) {
                                        $$iterated = true;
                                        var segment = $$obj[segmentIndex];
                                        $$eachNodes = $$eachNodes.concat((function() {
                                          var __jade_nodes = [];
                                          __jade_nodes = __jade_nodes.concat(h("li", {
                                            "class": {
                                              'bar_container': true
                                            },
                                          }, (function() {
                                            var __jade_nodes = [];
                                            const {
                                              color,
                                              count,
                                              isClickable,
                                              isSelected
                                            } = segment;
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "on": {
                                                click: isClickable ? ev => $helpers.clickBar(segment, label, rowIndex, queryIndex, ev) : null,
                                                mousemove: ev => $helpers.handleMouseMove(row, segmentIndex, false, ev),
                                                mouseleave: $helpers.handleMouseLeave,
                                              },
                                              "style": $helpers.formatBarStyle(segment),
                                              "class": Object.assign({}, {
                                                'not-clickable': !isClickable,
                                                'selected': !!isSelected
                                              }, {
                                                'bar': true,
                                                'hoverable': true
                                              }),
                                            }));
                                            __jade_nodes = __jade_nodes.concat(h("div", {
                                              "style": {
                                                width: `${100-$helpers.formatBarWidth(segment)}%`
                                              },
                                              "class": {
                                                'bar': true,
                                                'empty': true
                                              },
                                            }, (function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat(h("div", {
                                                "class": {
                                                  'bar_value': true
                                                },
                                              }, [__vjadeSafeCode($attr(`display-relative`) && !$helpers.isNil(segment.percentage) ? `${segment.percentage}%` : $helpers.commaizeNumber(segment.count))]));
                                              __jade_nodes = __jade_nodes.concat((segment.annotation) ? ((function() {
                                                var __jade_nodes = [];
                                                __jade_nodes = __jade_nodes.concat(h("div", {
                                                  "class": {
                                                    'annotation_line': true
                                                  },
                                                }));;
                                                return __jade_nodes
                                              }).call(this)) : undefined);;
                                              return __jade_nodes
                                            }).call(this).filter(Boolean)));
                                            __jade_nodes = __jade_nodes.concat((segment.annotation) ? ((function() {
                                              var __jade_nodes = [];
                                              __jade_nodes = __jade_nodes.concat(h("div", {
                                                "class": {
                                                  'annotation_container': true
                                                },
                                              }, (function() {
                                                var __jade_nodes = [];
                                                __jade_nodes = __jade_nodes.concat(h("div", {
                                                  "on": {
                                                    mousemove: ev => $helpers.handleMouseMove(row, segmentIndex, true, ev),
                                                    mouseleave: $helpers.handleMouseLeave,
                                                  },
                                                  "class": {
                                                    'annotation_label': true
                                                  },
                                                }, (function() {
                                                  var __jade_nodes = [];
                                                  __jade_nodes = __jade_nodes.concat(h("div", {
                                                    "style": $helpers.formatAnnotationStyle(segment),
                                                    "class": {
                                                      'color-indicator': true
                                                    },
                                                  }));
                                                  __jade_nodes = __jade_nodes.concat("" + (segment.annotation.value) + "");;
                                                  return __jade_nodes
                                                }).call(this).filter(Boolean)));;
                                                return __jade_nodes
                                              }).call(this).filter(Boolean)));;
                                              return __jade_nodes
                                            }).call(this)) : undefined);;
                                            return __jade_nodes
                                          }).call(this).filter(Boolean)));;
                                          return __jade_nodes
                                        }).call(this));
                                      }
                                    })();
                                  }
                                }

                                return $$eachNodes;
                              })());;
                              return __jade_nodes
                            }).call(this).filter(Boolean)));;
                            return __jade_nodes
                          }).call(this)));;
                          return __jade_nodes
                        }).call(this).filter(Boolean)));;
                        return __jade_nodes
                      }).call(this).filter(Boolean)));;
                      return __jade_nodes
                    }).call(this));
                  }
                })();
              }
            }

            return $$eachNodes;
          })());;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "Array" in locals ? locals.Array : typeof Array !== "undefined" ? Array : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "String" in locals ? locals.String : typeof String !== "undefined" ? String : undefined, "data" in locals ? locals.data : typeof data !== "undefined" ? data : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;